import React, { useEffect, useState } from "react";
import { Menu, X, Languages } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user, setAuthModal, logout } = useAuth();
  const { c, lang, toggle } = useLang();
  const navigate = useNavigate();

  const links = [
    [c.nav.howItWorks, "#how"],
    [c.nav.liveDeals, "#deals"],
    [c.nav.calculator, "#calculator"],
    [c.nav.blog, "#blog"],
    [c.nav.strategy, "#contact"],
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const LangBtn = ({ full }) => (
    <button onClick={toggle} title="Translate" style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "transparent", border: "1px solid rgba(201,162,75,0.4)", color: "var(--gold)", borderRadius: 999, padding: "0.4rem 0.8rem", cursor: "pointer", fontSize: "0.7rem", letterSpacing: "0.1em", transition: "background 0.2s ease" }}>
      <Languages size={14} /> {lang === "en" ? "ES" : "EN"}{full ? (lang === "en" ? " · Español" : " · English") : ""}
    </button>
  );

  return (
    <header style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 100, transition: "all 0.35s ease", background: scrolled ? "rgba(10,10,12,0.9)" : "transparent", backdropFilter: scrolled ? "blur(12px)" : "none", borderBottom: scrolled ? "1px solid rgba(255,255,255,0.06)" : "1px solid transparent" }}>
      <div className="container-x" style={{ maxWidth: 1280, display: "flex", alignItems: "center", justifyContent: "space-between", height: 76 }}>
        <a href="#top" className="font-serif" style={{ fontSize: "1.55rem", textDecoration: "none", letterSpacing: "0.02em" }}>
          <span style={{ color: "var(--text)" }}>DSCR</span><span style={{ color: "var(--gold)" }}>Daily</span>
        </a>

        <nav className="hidden lg:flex" style={{ gap: "2rem", alignItems: "center" }}>
          {links.map(([label, href]) => (
            <a key={href} href={href} className="link-hover" style={{ color: "var(--muted)", textDecoration: "none", fontSize: "0.72rem", letterSpacing: "0.14em", textTransform: "uppercase" }}>{label}</a>
          ))}
        </nav>

        <div className="hidden lg:flex" style={{ gap: "0.8rem", alignItems: "center" }}>
          <LangBtn />          {user ? (
            <>
              <button className="btn-dark" onClick={() => navigate("/dashboard")}>{c.nav.dashboard}</button>
              <button className="btn-gold" onClick={logout}>{c.nav.signOut}</button>
            </>
          ) : (
            <>
              <button className="btn-dark" onClick={() => setAuthModal("signin")}>{c.nav.signIn}</button>
              <button className="btn-gold" onClick={() => setAuthModal("signup")}>{c.nav.joinFree}</button>
            </>
          )}
        </div>

        <div className="flex lg:hidden" style={{ alignItems: "center", gap: "0.8rem" }}>
          <LangBtn />
          <button onClick={() => setOpen(!open)} style={{ background: "none", border: "none", color: "var(--text)", cursor: "pointer" }}>
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden" style={{ background: "#0d0d10", borderTop: "1px solid rgba(255,255,255,0.06)", padding: "1.5rem 2rem", display: "flex", flexDirection: "column", gap: "1.2rem" }}>
          {links.map(([label, href]) => (
            <a key={href} href={href} onClick={() => setOpen(false)} style={{ color: "var(--muted)", textDecoration: "none", fontSize: "0.8rem", letterSpacing: "0.12em", textTransform: "uppercase" }}>{label}</a>
          ))}
          <div style={{ display: "flex", gap: "0.7rem", marginTop: "0.5rem" }}>
            {user ? (
              <>
                <button className="btn-dark" style={{ flex: 1 }} onClick={() => navigate("/dashboard")}>{c.nav.dashboard}</button>
                <button className="btn-gold" style={{ flex: 1 }} onClick={logout}>{c.nav.signOut}</button>
              </>
            ) : (
              <>
                <button className="btn-dark" style={{ flex: 1 }} onClick={() => { setOpen(false); setAuthModal("signin"); }}>{c.nav.signIn}</button>
                <button className="btn-gold" style={{ flex: 1 }} onClick={() => { setOpen(false); setAuthModal("signup"); }}>{c.nav.joinFree}</button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
